import { Tooltip, Typography } from "antd";

import { useRecommendedInterventionsBarData } from "./ObservationRecommendedInterventionsBar.hook";

import "./ObservationRecommendedInterventionsBar.style.less";

const { Text } = Typography;

const ObservationRecommendedInterventionsBar = ({ observation }) => {
  const { barData, done, total } =
    useRecommendedInterventionsBarData(observation);

  return (
    <div className="observation-recommended-interventions-bar">
      <div className="states-bar">
        {Object.values(barData).map(({ key, tooltip, width, color }) => (
          <Tooltip key={key} title={tooltip}>
            <div className="state-bar" style={{ width, background: color }} />
          </Tooltip>
        ))}
      </div>
      <Text className="progress-infos">
        <strong>{total > 0 ? `${done} / ${total}` : 0}</strong>
      </Text>
    </div>
  );
};

export default ObservationRecommendedInterventionsBar;
